import { makeStyles } from '@mui/styles'
import { SILVER_SAND, WHITE } from '@returnmates/client-core/src/constants/colors'

interface StyleProps {
  isMainPage: boolean
  isSidebarOpen: boolean
}

const useStyles = makeStyles(() => ({
  root: {},
  main: {
    padding: ({ isMainPage }: StyleProps) => (isMainPage ? '80px 0 0 55px' : '115px 0 0 55px'),
    overflowX: 'hidden',
    overflowY: 'auto',
    height: '100vh',
    width: ({ isSidebarOpen }: StyleProps) => (isSidebarOpen ? '70%' : '100%'),
  },
  spinnerHandler: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
  },
  header: {
    position: 'fixed',
    width: ({ isSidebarOpen }: StyleProps) => (isSidebarOpen ? '70%' : '100%'),
    height: 80,
    top: 0,
    left: 0,
    zIndex: 103,
    backgroundColor: WHITE,
  },
  sidebar: {
    zIndex: 104,
    position: 'fixed',
    width: '30%',
    height: '100%',
    top: 0,
    right: 0,
    borderLeft: `1px solid ${SILVER_SAND}`,
  },
}))

export default useStyles
